/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLocationPlus: {
  name: 'location-plus';
  data: string;
} = {
  name: 'location-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a6 6 0 0 0-6 6c0 1.703.995 3.685 2.346 5.545 1.298 1.787 2.804 3.301 3.654 4.103.85-.802 2.357-2.316 3.654-4.103C17.004 13.685 18 11.703 18 10a6 6 0 0 0-6-6Zm-8 6a8 8 0 1 1 16 0c0 2.369-1.326 4.79-2.728 6.72-1.428 1.968-3.07 3.605-3.954 4.434a1.92 1.92 0 0 1-2.636 0c-.884-.83-2.526-2.466-3.954-4.434C5.326 14.79 4 12.37 4 10Zm8-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1V8a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
